import React from "react";
import { Link } from "react-router-dom";
import { Section, SerifH, Eyebrow, PrimaryButton } from "../components/ui-kit/Primitives";

const NotFound = () => (
  <Section className="pt-24">
    <Eyebrow>404</Eyebrow>
    <SerifH as="h1" className="text-5xl sm:text-6xl">This pathway does not exist — yet.</SerifH>
    <p className="mt-6 text-slate-600 max-w-xl">Let us get you back on track.</p>
    <div className="mt-8"><PrimaryButton to="/" testid="notfound-home">Return Home</PrimaryButton></div>
  </Section>
);

export default NotFound;
